import { useEffect } from "react";
import {
  preloadServiceImages,
  serviceImageMap,
} from "@/config/service-images";

export default function ServiceVisual({ image }: { image: string }) {
  useEffect(() => {
    // Wait for the initial page load so slides don't compete with critical assets.
    const schedule = () => {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(preloadServiceImages, { timeout: 2000 });
      } else {
        setTimeout(preloadServiceImages, 200);
      }
    };

    if (document.readyState === "complete") {
      schedule();
      return;
    }

    window.addEventListener("load", schedule, { once: true });
    return () => window.removeEventListener("load", schedule);
  }, []);

  return (
    <img
      src={serviceImageMap[image]}
      alt=""
      className="max-h-full w-full select-none object-contain drop-shadow-[0_30px_60px_rgba(0,0,0,0.55)]"
      loading="eager"
      decoding="sync"
      draggable={false}
    />
  );
}
